//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getResult } from './data'
import { tips } from './const'
import share from './_mixins/share'
export default {
    mixins: [
        share
    ],
    data () {
        return {
            res: {},
            tips
        }
    },
    mounted () {
        const res = getResult()
        this.res = res
    },
    methods: {
        openDetail () {
            const link = 'https://mp.weixin.qq.com/s/tW6kMq0Y8i3E5JWKZlZ7eA'
            wx.navigateTo({
                url: `/web_page?link=${encodeURIComponent(link)}&title=`
            })
        }
    }
}
